const MARKETPLACE_SOURCE = "MARKETPLACE";

export const isMarketplaceTransaction = (source?: string | null): boolean =>
  String(source ?? "")
    .trim()
    .toUpperCase() === MARKETPLACE_SOURCE;
